import React, { useEffect } from 'react';
import { Container } from '@mui/material';
import { Routes, Route, useLocation } from 'react-router-dom';
import SalaryCalculator from '../pages/SalaryCalculator';
import About from '../pages/About';
import AboutTheSalaryCalculator from '../pages/AboutTheSalaryCalculator';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfService from '../pages/TermsOfService';
import CookiePolicy from '../pages/CookiePolicy';
import Homepage from '../pages/HomePage';
import NewHomePage from '../pages/NewHomePage';
import SalarySpecificPage from '../pages/SalarySpecificPage';
import SalaryComparison from '../components/salaryComparison/SalaryComparison';
import TakeHomeSimple from '../pages/TakeHomeSimple';
import PayRiseSimulator from '../pages/PayRiseSimulator';
import AdminDev from '../pages/AdminDev';
import Admin from '../pages/Admin';
import { initGA, trackPageView } from '../analytics';
import { isFeatureEnabled } from '../featureFlags';

const MainContent = () => {
  const location = useLocation();

  useEffect(() => {
    initGA(); // Initialize Google Analytics once
    trackPageView(location.pathname); // Track page views when the route changes
    
    // Track page view server-side (consent-free)
    fetch('/api/pageview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        path: location.pathname,
        referrer: document.referrer 
      })
    }).catch(() => {}); // Silent fail
    
    // Listen for cookie consent changes and reinitialize GA
    const handleConsentChange = () => {
      initGA();
    };
    
    window.addEventListener('cookieConsentChanged', handleConsentChange);
    
    
    return () => {
      window.removeEventListener('cookieConsentChanged', handleConsentChange);
    };
  }, [location]);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ px: 0 }}
    >
      <Routes>
        <Route path="/" element={isFeatureEnabled('NEW_HOMEPAGE') ? <NewHomePage /> : <Homepage />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/salary-calculator" element={<SalaryCalculator />} />
        {isFeatureEnabled('SALARY_COMPARISON') && (
          <Route path="/salary-comparison" element={<SalaryComparison />} />
        )}
        {isFeatureEnabled('SIMPLE_TAKE_HOME_CALCULATOR') && (
          <Route path="/tools/take-home-simple" element={<TakeHomeSimple />} />
        )}
        {isFeatureEnabled('PAY_RISE_SIMULATOR') && (
          <Route path="/pay-rise-simulator" element={<PayRiseSimulator />} />
        )}
        <Route path="/about-the-salary-calculator" element={<AboutTheSalaryCalculator />} />
        <Route path="/admin" element={<Admin />} />
        {process.env.NODE_ENV === 'development' && (
          <Route path="/admin-dev" element={<AdminDev />} />
        )}
        <Route path="/:salaryAmount" element={<SalarySpecificPage />} />
      </Routes>
    </Container>
  );
};

export default MainContent;
